export const SVGGroup = {
  Betting: 'betting',
  Connect: 'connect',
  Fantasy: 'fantasy',
  Icons: 'icons',
  NFL: 'nfl',
  NCAA: 'ncaa',
  NFLBackground: 'nfl-background',
}
